/**
 * Die Suche des Board-Suchfelds - aus dem `useMemo` von `components/Board/BoardSeite.tsx` gezogen
 * (Nacharbeit zum KI-Zugang, Stufe 1), damit der Server (Werkzeug `bestellungen_suchen`) mit DEMSELBEN
 * Quelltext sucht wie die Oberflaeche. Keine Aenderung an der Suche selbst: dieselben Felder in
 * derselben Reihenfolge, dieselbe Normalisierung, dasselbe `includes`.
 *
 * Welche Felder der Heuhaufen liest, wann ein Feld dazukam oder entfiel und warum, steht im
 * Kopfkommentar von `components/Board/BoardSeite.tsx` (Eigenheit 1); die Kommentare an den Feldern
 * unten sind von dort mitgezogen.
 *
 * `query` ist BEREITS mit `normSearch` normalisiert (`BoardSeite.tsx` rechnet `normSearch(sucheRoh)`
 * einmal je Darstellung, nicht je Bestellung). Eine leere `query` trifft jede Bestellung.
 *
 * Regel fuer dieses Modul (`test/lib/reineKette.test.ts`): die Importkette enthaelt nur `.ts`-Dateien
 * unter `frontend/src`, nichts aus React und nichts aus dem Browser. Der Server kopiert die Datei
 * zeichengleich (`backend/scripts/ki-auswertung-kopieren.ts`).
 */
import { normSearch } from "./format.ts";
import type { Order } from "./types.ts";

export function bestellungTrifftSuche(order: Order, query: string): boolean {
  if (!query) return true;
  const haystack = [
    order.orderNo,
    order.name,
    // `trackingNo` stand hier bis zum 2026-08-25 als zehnter Eintrag - gestrichen, weil das
    // Feld im neuen Modell nie befuellt wird (Eigenheit 1 im Kopfkommentar von
    // `components/Board/BoardSeite.tsx`, mit Messung).
    order.supplier,
    order.invoiceNo,
    order.piNo,
    order.paymentTerms,
    // Asana "Suchfunktion erweitern" (1218171668442051, 2026-09-04): Bezugsauftrag und
    // Notizen - beide bereits am Order-Objekt vorhanden (JTL-Merge), bisher nur nicht im
    // Heuhaufen (Eigenheit 1 im Kopfkommentar von `components/Board/BoardSeite.tsx`).
    order.bezugsAuftragsNummer,
    order.internerKommentar,
    // Sendungsnummer(n) - gespreadet wie `customFields`/`items` unten, jede Nummer als
    // eigener Heuhaufen-Eintrag. Siehe `dsvSendungsnummern` in lib/types.ts und die
    // Entscheidungsnotiz zur Sendungsquelle (Eigenheit 1 im Kopfkommentar von
    // `components/Board/BoardSeite.tsx`, Nachtrag 2026-09-04).
    ...(order.dsvSendungsnummern ?? []),
    ...Object.values((order.customFields as Record<string, unknown>) || {}),
    ...(((order.items as Record<string, unknown>[]) || []).flatMap((item) => [
      item.name,
      item.sku,
    ]) as unknown[]),
  ]
    .map(normSearch)
    .join(" ");
  return haystack.includes(query);
}
